import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  Label,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Badge,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import TableScrollbar from "react-table-scrollbar";
import "../PurchaseIndentRequest.scss";
import Swal from "sweetalert2";
import Moment from "moment";

import {
  getPIReqestRowDetails,
  PIitemHodApproval,
  PIHodApprovedRequest,
  SIInputChangeValue,
  SISelecteChangeValue,
  SRDetailsModel_open,
  getMrItemImages,
  productItemHistoryModelOpen,
} from "../../../store/SRPurchaseIndent/actions";
import {
  ChangeItemModelOpen,
  getAllProducts,
} from "../../../store/MaterialRequest/actions";

import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import Defaultuser from "../../../assets/images/users/Default_User.png";
import GetMRDetails from "../../GetSRDetails";
import LoadingModel from "../../LoadingModel";
import ChangeItem from "../../Material/ChangeItem";
import ItemDetails from "../../ItemDetails";
import PIProductItemHistoryLog from "../PIProductItemHistoryLog";

// import userimg2 from "../../../assets/images/small/img-2.jpg";

function PdfViewer({ url }) {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        let finalUrl = url;

        if (
          window.location.hostname === "localhost" &&
          url.startsWith("http://vendpin.dev.absol.in")
        ) {
          finalUrl = url.replace("http://vendpin.dev.absol.in", "");
        }

        const response = await fetch(finalUrl);
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(blobUrl);
      } catch (err) {
        console.error("Failed to load PDF", err);
      }
    };
    fetchPdf();
  }, [url]);

  if (!pdfBlobUrl)
    return <p style={{ padding: "10px" }}>Loading PDF preview...</p>;

  return (
    <iframe
      src={pdfBlobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}
class HodPurchaseOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      reqStateRowData: [],
      request_items: [],
      products: [],
      productdata: {},
      selectedOrderLocation: null,
      showImageModal: false,
    };
    this.itemApprovedRequest = this.itemApprovedRequest.bind(this);
    this.updateApprovedRequest = this.updateApprovedRequest.bind(this);
    this.tog_static = this.tog_static.bind(this);
  }
  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      productdata: item,
    }));
    if (item?.siisris?.length !== 0) {
      this.props.getMrItemImages(
        item.id,
        item?.siisris[item?.siisris.length - 1]?.sritem?.id
      );
    }
    this.removeBodyCss();
  }
  reject_Model(Reject, item) {
    this.setState((prevState) => ({
      rejectModel: !prevState.rejectModel,
      rejectItem: item,
      rejectItemText: "",
      rejectErrorMsg: "",
      reject: Reject,
    }));
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  itemApprovedRequest = (item, sistatus) => {
    var siisris = item.siisris.map((p) => {
      p.mritem_id = p.sritem.id;
      p.unit_id = p.unit.id;

      return p;
    });
    var data = {
      sistatus: sistatus,
      purchaseindent_id: this.props.PIRowData.id,
      piitem_id: item.id,
      t_product_id: item.product.id,
      t_make: item.make,
      t_description: item.description,
      t_qty: item.t_qty == null ? item.qty : item.t_qty,
      t_unit: item.t_unit == null ? item.unit.id : item.t_unit,
      siisris: siisris,
      description: this.state.rejectItemText,
    };
    if (sistatus === 3) {
      Swal.fire({
        title: "Are you sure approval this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.PIitemHodApproval(data, this.props.history);
        }
      });
    }
    if (sistatus === 4) {
      if (data.description !== "") {
        this.props.PIitemHodApproval(data, this.props.history);
        this.setState({ rejectModel: false });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }
  };
  updateApprovedRequest(sistatus) {
    var siitems = [];
    this.props.PIRowData.siitems.map((piitem) => {
      if (piitem.sistatus === 1 || piitem.sistatus === 1) {
        var siisris1 = piitem.siisris.map((p) => {
          p.sritem_id = p.sritem?.id;
          p.unit_id = p.unit.id;

          return p;
        });
        var ItemData = {
          sistatus: sistatus,
          serviceindent_id: this.props.PIRowData.id,
          siitem_id: piitem.id,
          t_product_id: piitem.product.id,
          t_make: piitem.make,
          t_description: piitem.description,
          t_qty: piitem.t_qty == null ? piitem.qty : piitem.t_qty,
          t_unit: piitem.t_unit == null ? piitem.unit.id : piitem.t_unit,
          siisris: siisris1,

          description: this.state.rejectItemText,
        };
        siitems.push(ItemData);
      }
      return 0;
    });
    var data = {
      sistatus: sistatus,
      serviceindent_id: this.props.PIRowData.id,
      siias: siitems,
      description: this.state.rejectItemText,
    };
    if (sistatus === 3) {
      Swal.fire({
        title: "Are you sure approve this SI?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.PIHodApprovedRequest(data, this.props.history);
        }
      });
    }
    if (sistatus === 4) {
      if (data.description !== "") {
        this.props.PIHodApprovedRequest(data, this.props.history);
        this.setState({ rejectItemModel: false });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }
  }

  componentDidMount() {
    this.props.getPIReqestRowDetails(
      this.props.match.params.id,
      this.props.history
    );
  }
  SItemChangeHandeler(e, item) {
    // var itemqty = item.siisris.map((i) => {
    //   return i.qty + i.sritem.availableqty;
    // });
    // var totalitemqty = itemqty.reduce((total, itemqty) => total + itemqty);
    // if (e.target.value >= totalitemqty) {
    //   this.props.SIInputChangeValue({
    //     key: e.target.name,
    //     value: parseFloat(e.target.value),
    //     item,
    //   });
    // } else {
    //   swal("Minimum Quantity is " + totalitemqty, {
    //     icon: "error",
    //   });
    this.props.SIInputChangeValue({
      key: e.target.name,
      value: e.target.value,
      item,
    });
    // }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <AvForm className="needs-validation">
              <Row>
                <Col md={12}>
                  <Card className="mb-0 mt-0">
                    <CardHeader className="bg-transparent border-bottom ">
                      <Link
                        to="/srpidashboard1"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>

                      <h5 className="card-title-18 pt-2 d-inline-block">
                        Service Indent Request (#
                        {this.props.PIRowData?.code})
                      </h5>
                      <div className="float-right">
                        <div className="d-inline-block ">
                          <Link
                            to={"/sireportdoc/" + this.props.match.params.id}
                            className="action-icon text-primary mr-2"
                          >
                            <Button
                              type="button"
                              outline
                              color="secondary"
                              className=" mr-2"
                            >
                              <i className="mdi  mdi-printer"></i>
                              <span className="d-none d-inline-block ml-1">
                                Print
                              </span>
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody className="pt-1">
                      <Row className="p-1">
                        <Col md={12} className="p-1 m-0 border-bottom">
                          <div className="p-1 m-0">
                            <CardBody className="pt-1 pb-1">
                              <Row className="p-0">
                                <Col md={8} className="p-1 m-0">
                                  <div className="Indent-Request-panel-content">
                                    <div className="list-column">
                                      <Row>
                                        <Col md={6}>
                                          <ul className="list-style-two p-0">
                                            <li className="clearfix">
                                              <span className="ttl">
                                                Request By:
                                              </span>
                                              <span className="dtl">
                                                <ul className="user-column p-0">
                                                  <li className="clearfix p-0 m-0">
                                                    <span className="img">
                                                      <img
                                                        className="img-fluid p-0"
                                                        src={
                                                          this.props.PIRowData
                                                            ?.createdby
                                                            ?.image == null
                                                            ? Defaultuser
                                                            : this.props
                                                                .PIRowData
                                                                ?.createdby
                                                                ?.image
                                                        }
                                                        alt="user"
                                                      />
                                                    </span>
                                                    <span className="userttl">
                                                      {
                                                        this.props.PIRowData
                                                          ?.createdby?.fullname
                                                      }
                                                    </span>
                                                  </li>
                                                </ul>
                                              </span>
                                            </li>
                                            <li className="clearfix">
                                              <span className="ttl">
                                                Location:{" "}
                                              </span>
                                              <span className="dtl">
                                                {
                                                  this.props.PIRowData?.location
                                                    ?.name
                                                }
                                              </span>
                                            </li>

                                            <li className="clearfix">
                                              <span className="ttl">
                                                Order Location:
                                              </span>
                                              <span className="dtl">
                                                {
                                                  this.props.PIRowData
                                                    ?.orderlocation?.name
                                                }

                                                {this.props.PIRowData
                                                  ?.orderlocation?.image && (
                                                  <Button
                                                    color="info"
                                                    size="sm"
                                                    className="ml-2"
                                                    onClick={() =>
                                                      this.setState({
                                                        selectedOrderLocation:
                                                          this.props.PIRowData
                                                            ?.orderlocation,
                                                        showImageModal: true,
                                                      })
                                                    }
                                                  >
                                                    View
                                                  </Button>
                                                )}
                                              </span>
                                            </li>

                                            <li className="clearfix">
                                              <span className="ttl">
                                                User Department:
                                              </span>
                                              <span className="dtl">
                                                {
                                                  this.props.PIRowData
                                                    ?.userdepartment?.name
                                                }
                                              </span>
                                            </li>
                                            <li className="clearfix">
                                              <span className="ttl">
                                                description:
                                              </span>
                                              <span className="dtl">
                                                {
                                                  this.props.PIRowData
                                                    ?.description
                                                }
                                              </span>
                                            </li>
                                          </ul>
                                        </Col>
                                        <Col md={6}>
                                          <ul className="list-style-two p-0">
                                            <li className="clearfix">
                                              <span className="ttl">
                                                Department:
                                              </span>
                                              <span className="dtl">
                                                {
                                                  this.props.PIRowData
                                                    ?.department?.name
                                                }
                                              </span>
                                            </li>
                                            <li className="clearfix">
                                              <span className="ttl">
                                                Submited Date:
                                              </span>
                                              <span className="dtl">
                                                {" "}
                                                {Moment(
                                                  this.props.PIRowData
                                                    ?.createdon
                                                ).format("DD-MM-YYYY")}
                                              </span>
                                            </li>
                                            <li className="clearfix">
                                              <span className="ttl">
                                                Status:
                                              </span>

                                              <span className="dtl font-size-18">
                                                <Badge
                                                  color={
                                                    this.props.PIRowData
                                                      ?.sistatus === 1 ||
                                                    this.props.PIRowData
                                                      ?.sistatus === 2
                                                      ? "primary "
                                                      : this.props.PIRowData
                                                          ?.sistatus === 3
                                                      ? "success "
                                                      : "danger "
                                                  }
                                                >
                                                  {
                                                    this.props.PIRowData
                                                      ?.sistatus_name
                                                  }
                                                </Badge>
                                              </span>
                                            </li>
                                          </ul>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                                <Col md={4} className="p-1 m-0">
                                  {!this.props.PIRowData?.loading &&
                                    (this.props.PIRowData?.sistatus === 1 ||
                                      this.props.PIRowData?.sistatus === 2) && (
                                      <>
                                        <div className="PIApprovedBox">
                                          <Button
                                            type="button"
                                            block
                                            color="success"
                                            className=" mr-2"
                                            onClick={() => {
                                              this.updateApprovedRequest(3);
                                            }}
                                          >
                                            <i className="mdi mdi-thumb-up mr-2"></i>
                                            Approve
                                          </Button>

                                          <Button
                                            type="button"
                                            block
                                            disabled={
                                              this.props.PiApprovedItems
                                                .length === 0
                                                ? false
                                                : true
                                            }
                                            color="danger"
                                            onClick={() =>
                                              this.reject_Model("PiReject", "")
                                            }
                                          >
                                            <i className="mdi mdi-thumb-down mr-2"></i>
                                            Reject
                                          </Button>
                                        </div>
                                      </>
                                    )}
                                </Col>
                              </Row>
                            </CardBody>
                          </div>
                        </Col>
                        <Col
                          md={12}
                          xl={this.state.showImageModal ? 5 : 8}
                          className="p-1"
                        >
                          <div className="p-1">
                            <Col md={12} className="m-0">
                              <div
                                style={{
                                  textAlign: "left",
                                  background: "#FFF",
                                  padding: "5px;",
                                }}
                              >
                                <h3 className="card-title-15 pt-2">
                                  SR Purchase Indent Items List
                                </h3>
                              </div>
                              <div className="table-responsive m-0">
                                <TableScrollbar height="450px">
                                  <Table className="mb-0 p-0 table-centered  ">
                                    <thead className="bg-light text-center">
                                      <tr>
                                        <th className="nowrap">SR Details</th>
                                        <th className="nowrap">Item Images</th>
                                        <th
                                          style={{
                                            minWidth: "120px",
                                          }}
                                        >
                                          Item Name
                                        </th>
                                        <th className="nowrap">Required Qty</th>
                                        <th
                                          style={{
                                            minWidth: "120px",
                                          }}
                                        >
                                          Indent Quantity
                                        </th>
                                        <th className="nowrap">Department</th>

                                        <th className="nowrap">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.props.PIRowData?.siitems?.map(
                                        (item, key) => (
                                          <tr key={key}>
                                            <td className="nowrap text-center">
                                              {item?.siisris.length === 0 ? (
                                                <>
                                                  <span>
                                                    {" "}
                                                    <u>View</u>
                                                  </span>
                                                </>
                                              ) : (
                                                <Link
                                                  to="#"
                                                  onClick={() => {
                                                    this.props.SRDetailsModel_open(
                                                      item?.siisris[
                                                        item?.siisris.length - 1
                                                      ].sritem
                                                        ?.servicerequest_id
                                                    );
                                                  }}
                                                  className="text-primary mr-1"
                                                >
                                                  <u>View</u>
                                                </Link>
                                              )}
                                            </td>
                                            <td className="nowrap text-center">
                                              <div className="product-detail text-center">
                                                <img
                                                  src={
                                                    item?.product?.image == null
                                                      ? DefaultImg
                                                      : item?.product?.image
                                                  }
                                                  alt="product-img"
                                                  title="product-img"
                                                  className="product-img  img-fluid mx-auto tab-img rounded"
                                                  style={{
                                                    height: "100px",
                                                    width: "150px",
                                                  }}
                                                />
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                minWidth: "120px",
                                              }}
                                            >
                                              <h5 className="font-size-14 ">
                                                <Link
                                                  to="#"
                                                  onClick={() => {
                                                    this.tog_static(item);
                                                  }}
                                                  className="text-dark mr-1"
                                                >
                                                  {item?.product.name}
                                                </Link>
                                                {item.siisris.length === 0 && (
                                                  <Badge color="primary">
                                                    new
                                                  </Badge>
                                                )}
                                                {item?.sii_approvals.length !==
                                                  0 && (
                                                  <>
                                                    <Link
                                                      to="#"
                                                      onClick={() => {
                                                        this.props.productItemHistoryModelOpen(
                                                          item.sii_approvals
                                                        );
                                                      }}
                                                      className="text-dark"
                                                    >
                                                      <i className=" text-primary ri-eye-fill ml-2"></i>
                                                    </Link>
                                                  </>
                                                )}
                                                {/* {item.mrstatus !== 12 && (
                                                  <Link
                                                    to="#"
                                                    onClick={() => {
                                                      this.props.ChangeItemModelOpen(
                                                        item,
                                                        "MRISHod",
                                                        {
                                                          purchaseindent_id:
                                                            this.props.PIRowData
                                                              .id,
                                                          piitem_id: item.id,
                                                          siisris: item.siisris,
                                                        }
                                                      );
                                                      this.props.getAllProducts(
                                                        {
                                                          ...this.props.params,
                                                          search: "",
                                                          page: 1,
                                                        },
                                                        true
                                                      );
                                                    }}
                                                    className="ml-2 text-primary"
                                                  >
                                                    <i className="ri-pencil-line"></i>
                                                  </Link>
                                                )} */}
                                              </h5>
                                              <p className="mb-0">
                                                Make :{" "}
                                                <span className="font-weight-medium">
                                                  {item.make}
                                                </span>
                                              </p>
                                              <p className="mb-0">
                                                Description :{" "}
                                                <span className="font-weight-medium">
                                                  {item.description}
                                                </span>
                                              </p>
                                              {/* {item.sistatus === 4 && (
                                                <p className="mb-0">
                                                  <b className="text-danger ">
                                                    Reject Remark :
                                                  </b>{" "}
                                                  <span>
                                                    {
                                                      item.mri_approvals[
                                                        item.mri_approvals
                                                          .length - 1
                                                      ].description
                                                    }
                                                  </span>
                                                </p>
                                              )} */}
                                            </td>
                                            <td className="nowrap text-center">
                                              {item.sii_approvals.length === 0
                                                ? item.qty +
                                                  " " +
                                                  item.unit?.name
                                                : item.sii_approvals[0].f_qty +
                                                  " " +
                                                  item.sii_approvals[0].f_unit
                                                    .name}
                                            </td>
                                            <td
                                              className="text-center"
                                              style={{
                                                minWidth: "120px",
                                              }}
                                            >
                                              {item.sistatus === 1 ||
                                              item.sistatus === 2 ? (
                                                <>
                                                  <FormGroup
                                                    row
                                                    className="mb-0"
                                                  >
                                                    <Col md={3}>
                                                      <Label
                                                        htmlFor="Qty"
                                                        className="col-form-label float-left"
                                                      >
                                                        Qty :
                                                      </Label>
                                                    </Col>
                                                    <Col md={9}>
                                                      <AvField
                                                        placeholder="Quantity"
                                                        className=" pr-0form-control"
                                                        min={0}
                                                        // max={100}
                                                        type="number"
                                                        validate={{
                                                          required: {
                                                            value: true,
                                                            errorMessage:
                                                              "Please enter Qty",
                                                          },
                                                          pattern: {
                                                            value:
                                                              "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                                            errorMessage:
                                                              "Qty can compose numbers and 3 decimals ",
                                                          },
                                                        }}
                                                        name={key + "qty"}
                                                        id="qty"
                                                        value={item.qty}
                                                        onChange={(e) =>
                                                          this.SItemChangeHandeler(
                                                            e,
                                                            item
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                  </FormGroup>
                                                  <FormGroup
                                                    row
                                                    className="mb-0"
                                                  >
                                                    <Col md={3}>
                                                      <Label
                                                        htmlFor="Units"
                                                        className="col-form-label float-left"
                                                      >
                                                        Units :
                                                      </Label>
                                                    </Col>
                                                    <Col md={9}>
                                                      <Select
                                                        id="units_select"
                                                        name="units_select"
                                                        required="required"
                                                        options={item?.product?.units?.map(
                                                          (i) => ({
                                                            label: i.name,
                                                            value: i.id,
                                                          })
                                                        )}
                                                        value={{
                                                          label: item.unit.name,
                                                          value: item.unit.id,
                                                        }}
                                                        onChange={(e) => {
                                                          this.props.SISelecteChangeValue(
                                                            {
                                                              key: "unit_name",
                                                              label: e.label,
                                                              key2: "unit_id",
                                                              value: e.value,
                                                              item,
                                                            }
                                                          );
                                                        }}
                                                      />
                                                    </Col>
                                                  </FormGroup>
                                                </>
                                              ) : (
                                                <>
                                                  {item.qty} {item?.unit.name}
                                                </>
                                              )}
                                            </td>
                                            <td className="nowrap text-center">
                                              {item?.product?.department.name}
                                            </td>

                                            <td className="nowrap text-center">
                                              {item.sistatus === 1 ||
                                              item.sistatus === 2 ? (
                                                <>
                                                  <Button
                                                    type="button"
                                                    color="success"
                                                    className="waves-effect waves-light mr-2"
                                                    // style={{display:"none"}}

                                                    onClick={() => {
                                                      this.itemApprovedRequest(
                                                        item,
                                                        3
                                                      );
                                                    }}
                                                  >
                                                    <i className="mdi mdi-check"></i>
                                                  </Button>
                                                  <Button
                                                    type="button"
                                                    color="danger"
                                                    className="waves-effect waves-light"
                                                    onClick={() =>
                                                      this.reject_Model(
                                                        "PiItemReject",
                                                        item
                                                      )
                                                    }
                                                    // onClick={() => {
                                                    //   this.itemApprovedRequest(
                                                    //     item,
                                                    //     4
                                                    //   );
                                                    // }}
                                                  >
                                                    <i className="mdi mdi-close"></i>
                                                  </Button>
                                                </>
                                              ) : (
                                                <Badge
                                                  className="font-size-14"
                                                  color={
                                                    item.sistatus === 1 ||
                                                    item.sistatus === 2
                                                      ? "primary"
                                                      : item.sistatus === 3 ||
                                                        item.sistatus === 7 ||
                                                        item.sistatus === 8
                                                      ? "success"
                                                      : "danger"
                                                  }
                                                >
                                                  {item.sistatus_name}
                                                </Badge>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                </TableScrollbar>
                              </div>
                            </Col>
                          </div>
                        </Col>

                        {this.state.showImageModal &&
                          this.state.selectedOrderLocation?.image && (
                            <Col md={12} xl={3}>
                              <Card className="p-1">
                                <CardHeader>
                                  <h5>
                                    Order Location Document:{" "}
                                    {this.state.selectedOrderLocation.name}
                                  </h5>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={() =>
                                      this.setState({
                                        showImageModal: false,
                                      })
                                    }
                                  >
                                    Close
                                  </Button>
                                </CardHeader>
                                <CardBody className="p-0">
                                  {this.state.selectedOrderLocation?.image ? (
                                    (() => {
                                      const rawUrl =
                                        this.state.selectedOrderLocation.image;
                                      const cleanUrl = rawUrl.trim();
                                      const isPdf = /\.pdf(\?.*)?$/i.test(
                                        cleanUrl
                                      );

                                      return isPdf ? (
                                        <PdfViewer url={cleanUrl} />
                                      ) : (
                                        <img
                                          src={cleanUrl}
                                          alt="Order Location"
                                          style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                          }}
                                        />
                                      );
                                    })()
                                  ) : (
                                    <p style={{ padding: 10 }}>
                                      No document available
                                    </p>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                          )}
                      </Row>
                      <CardFooter className="bg-transparent pt-0">
                        <div className="float-right">
                          <Button
                            type="reset"
                            color="light"
                            className="waves-effect waves-light mr-2"
                            href="/srpidashboard1"
                          >
                            {/* <i className="mdi mdi-filter mr-1"></i> */}
                            Cancel
                          </Button>
                          {(this.props.PIRowData?.sistatus === 1 ||
                            this.props.PIRowData?.sistatus === 2) && (
                            <Button
                              type="submit"
                              color="success"
                              // disabled={btn_app_desable}
                              onClick={() => {
                                this.updateApprovedRequest(3);
                              }}
                              className="waves-effect waves-light mr-2"
                            >
                              Update & Approve
                            </Button>
                          )}
                        </div>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.productdata}
              ItemLevel="PILevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />

            <Modal
              isOpen={this.state.rejectModel}
              toggle={this.reject_Model}
              backdrop="static"
              centered
              // size="lg"
            >
              <ModalHeader toggle={() => this.setState({ rejectModel: false })}>
                Reject Remark
              </ModalHeader>
              <ModalBody className="pt-0">
                <Input
                  className="mb-0 form-control "
                  type="textarea"
                  step="1"
                  name="reject"
                  id="reject_item"
                  value={this.state.rejectItemText}
                  onChange={(e) =>
                    this.setState({
                      rejectItemText: e.target.value,
                    })
                  }
                  placeholder="Reject Description"
                />
                {this.state.rejectErrorMsg !== "" && (
                  <span className="text-danger mt-0">
                    {this.state.rejectErrorMsg}
                  </span>
                )}
                <div className="float-right mt-2">
                  <FormGroup>
                    <Button
                      type="button"
                      color="light "
                      className="waves-effect waves-light d-inline-block mr-2"
                      onClick={() =>
                        this.setState({
                          rejectModel: false,
                        })
                      }
                    >
                      Cancel
                    </Button>
                    {this.state.reject === "PiReject" && (
                      <Button
                        type="submit"
                        color="primary"
                        className="waves-effect waves-light d-inline-block"
                        onClick={() => {
                          this.updateApprovedRequest(4);
                        }}
                      >
                        Submit
                      </Button>
                    )}
                    {this.state.reject === "PiItemReject" && (
                      <Button
                        type="submit"
                        color="primary"
                        className="waves-effect waves-light d-inline-block"
                        onClick={() => {
                          this.itemApprovedRequest(this.state.rejectItem, 4);
                        }}
                      >
                        Submit
                      </Button>
                    )}
                  </FormGroup>
                </div>
              </ModalBody>
            </Modal>
            <ChangeItem />
            <PIProductItemHistoryLog />
            <GetMRDetails />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { PIRowData, PiApprovedItems, loading } = state.SRpurchaseIndent;
  return { PIRowData, PiApprovedItems, loading };
};

export default connect(mapStatetoProps, {
  getPIReqestRowDetails,
  PIitemHodApproval,
  PIHodApprovedRequest,
  SIInputChangeValue,
  SISelecteChangeValue,
  SRDetailsModel_open,
  ChangeItemModelOpen,
  getAllProducts,
  getMrItemImages,
  productItemHistoryModelOpen,
})(HodPurchaseOrder);
